module.exports = __webpack_public_path__ + "img/course101_curriculum.9c76a886.png";